import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { getIsFetchingIssueById } from "@adsk/acc-issues-core/state/redux/ducks/issuesCollection";

export const useIsFetchingIssue = (issueId?: string) =>
  useSelector(getIsFetchingIssueById)(issueId);
